import React from "react";
import { Outlet } from "react-router-dom";
import Fab from "../components/common/AmpFloatingActionButton/AmpFloatingActionButton";
import AmpFooter from "../components/common/AmpFooter/AmpFooter";
import HeaderNav from "../components/common/HeaderNav/HeaderNav";
import LanguageAccessibilty from "../components/common/LanguageAccessibility/LanguageAccessibilty";
import Logo from "../components/common/Logo/Logo";
import BlueNavTabs from "../components/landing/BlueNavTabs/BlueNavTabs";
import CurrentPropertyDisplayer from "../components/landing/CurrentPropertyDisplayer/CurrentPropertyDisplayer";

function Main(): JSX.Element {

  return (
    <div className={"root-login-layout main"}>
      <div className={"logo-nav-header"}>
        <div className="logo-parent">
          <Logo />
        </div>
        <CurrentPropertyDisplayer />
        <LanguageAccessibilty />
      </div>
      <div className={"header-second-row"}>
        <HeaderNav isAuthed={true}></HeaderNav>
      </div>
      <BlueNavTabs/>
      <Outlet/>
      <AmpFooter/>
      <Fab elementScrollQuery={".root-login-layout > *:nth-child(4)"}>Scroll to Content</Fab>
    </div>
  );
}

export default Main;
